import { memo } from 'react';

import { Props } from '@/components/JSONRender/types';

const JSONRender = ({ jsonObject, spacing = 2 }: Props) => {
  return (
    <div className="text-sm p-2 border border-gray-200 bg-gray-50 text-black rounded-lg">
      <pre className="mp-sensitive">{JSON.stringify(jsonObject, undefined, spacing)}</pre>
    </div>
  );
};

export default memo(JSONRender);
